import { gql } from '@apollo/client';

const GET_NATIONALITIES = gql`
  query GetNationalities {
    nationalitiesLA {
      id
      name
      isoCode
    }
  }
`;

export default GET_NATIONALITIES;